import styled, { css } from 'styled-components';
import { color, variant } from 'styled-system';
import { ThemeUtilities } from '../../../../../theme';
import { theme } from '../../../../../themeBase';
import { ComponentSize } from '../../../types';
import { OptionVariant } from '../../types';

export const SelectOption = styled.div<{
  selectSize: ComponentSize;
  optionVariant: OptionVariant;
  color?: string;
  divider?: boolean;
}>`
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Options', 'selectSize')
    )};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Options', 'optionVariant')
    )};
  transition: background-color 250ms ease-in-out;
  ${color};
  ${(props) =>
    props.divider &&
    css({
      borderBottom: `1px solid ${theme.colors.gray.extraLight}`,
    })};
`;
